// components/TreeItem.js
import React from 'react';

const TreeItem = React.memo(({ item, padding = 0, onToggleChecked, onToggleVisible, onShowNoteCanvas }) => {
  const handleToggleChecked = (e) => {
    onToggleChecked(item.id, e.target.checked); // Pasamos también el nuevo estado del checkbox
  };

  const handleNameClick = () => {
    // Solo alternamos la visibilidad si el ítem tiene hijos
    if (item.children && item.children.length > 0) {
      onToggleVisible(item.id);
    }
  };

  const handleShowNoteCanvas = () => {
    onShowNoteCanvas(item.id, item.name);
  }


  return (
    <div className='container-framework-list' style={{ marginLeft: '20px', paddingLeft: `${padding}px`, width: 'max-content' }}>
      <div>
        {item.children && item.children.length > 0 && (
          <span className='icon-open ' style={{ color: '#8d8d8d', fontFamily: "Inter, serif", cursor: 'pointer' }} onClick={handleNameClick}>{item.visible ? ' ▼' : ' ▶'}</span> // Indicador de expansión/contracción
        )}
        &nbsp;
        <label>
          <input
            type="checkbox"
            className="checkbox-frameworks"
            checked={item.checked}
            onChange={handleToggleChecked}
          />
        </label>
        &nbsp;
        {item.id}
        &nbsp;
        {/* Aquí es donde se maneja el click en el nombre */}
        <span
          onClick={handleNameClick}
          style={{
            cursor: item.children && item.children.length > 0 ? 'pointer' : 'default',
            fontWeight: item.children && item.children.length > 0 ? 'bold' : 'normal'
          }}
        >
          {item.name}

        </span>
        &nbsp;
        {item.checked && <i className="bi bi-file-text-fill" style={{ color: "#666666", cursor: 'pointer' }} onClick={handleShowNoteCanvas}></i>}
      </div>
      {/* Renderiza los hijos solo si item.visible es true y tiene hijos */}
      {item.visible && item.children && item.children.length > 0 && (
        <div>
          {item.children.map((child) => (
            <TreeItem
              key={child.id}
              item={child}
              padding={padding + 5} // Aumenta el padding para los hijos
              onToggleChecked={onToggleChecked}
              onToggleVisible={onToggleVisible}
              onShowNoteCanvas={onShowNoteCanvas}
            />
          ))}
        </div>
      )}
    </div>
  );
});

export default TreeItem;